module.exports = __webpack_public_path__ + "img/kyc-selection.bbea875e.png";